export default __webpack_public_path__ + "static/media/ChequeIcon.16a462ad.svg";